import { MdCheck } from 'react-icons/md';
import ApproveModal from './ApproveModal';
import { formatDateIfValid } from '~/utils';

interface Props {
  medCenter: any;
  approved: boolean;
  setApproved: any;
}

const MedicalCenterTitlePanel: React.FC<Props> = ({
  medCenter,
  approved,
  setApproved,
}) => {
  return (
    <>
      <div className='md:flex md:justify-between'>
        <div className='mb-6 md:mb-0'>
          <div className='flex'>
            <h1 className='text-[38px]/[44px]'>{medCenter?.name}</h1>
            <div className='ml-[7px] mt-[7px] w-[16px]'>
              {approved && <MdCheck color='#6BB841' size={40} />}
            </div>
          </div>

          <div className='flex'>
            <div
              className={`inline-flex rounded-full px-3 py-1 text-sm hover:bg-opacity-90 ${
                medCenter?.is_active === true
                  ? 'bg-primary'
                  : 'bg-whiten text-secondary'
              }`}
            >
              {medCenter?.is_active === true ? 'Active' : 'Inactive'}
            </div>
            <div className='ml-[15px] text-[16px]/[24px] text-[#949599]'>
              Last Updated:{' '}
              {formatDateIfValid(medCenter?.update_date, 'MM/dd/yy')}
            </div>
          </div>
        </div>

        <div className='md:flex md:items-center'>
          <ApproveModal
            name={medCenter?.name}
            id={medCenter?.id}
            setApproved={setApproved}
            approved={approved}
          />
        </div>
      </div>
    </>
  );
};

export default MedicalCenterTitlePanel;
